import { Type } from '@deqo/foundation';
import { CommandDefinition } from '../../../concepts/commands/CommandDefinition';
import { ToolBehavior } from './ToolBehavior';

export interface ToolDefinition {
    id: string;
    label: string;
    category: string;
    icon?: string;
    weight?: number;
    command?: CommandDefinition;
    behaviors?: Type<ToolBehavior>[];
    shortcut?: string;
    special?: boolean;
}

export const defineTool = (def: ToolDefinition): ToolDefinition => def;
